import '@ts/pages/page-defaults';
import '@ts/external/particles';
import '@ts/helpers/particles';
import { autoPlay } from '@ts/ui/carousel';
const carousel = document.getElementById('hero-carousel');
if (carousel) {
    autoPlay(carousel);
}
